import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=43f8eef4&scoped=true&"
import script from "./TreeItem.vue?vue&type=script&lang=ts&"
export * from "./TreeItem.vue?vue&type=script&lang=ts&"
import style0 from "./TreeItem.vue?vue&type=style&index=0&id=43f8eef4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f8eef4",
  null
  
)

export default component.exports